import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import FlipToFrontOutlinedIcon from "@mui/icons-material/FlipToFrontOutlined";
import HistoryIcon from "@mui/icons-material/History";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";

const Menu = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <BrandingWatermarkOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Service Request",
    path: "/serviceRequest",
    icon: <AssignmentOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Case History",
    path: "/caseHistory",
    icon: <HistoryIcon />,
    subMenu: [],
  },
  {
    title: "Staff Connect",
    path: "/feedback",
    icon: <FeedbackOutlinedIcon />,
    subMenu: [],
  },
  // {
  //   title: "Chat",
  //   path: "/chat",
  //   icon: <ChatIcon />,
  //   subMenu: [],
  // },
  {
    title: "Transaction",
    path: "/transaction",
    icon: <FlipToFrontOutlinedIcon />,
    subMenu: [],
  },
  // {
  //   title: "Client Survey",
  //   path: "/settings",
  //   icon: <PollOutlinedIcon />,
  //   subMenu: [],
  // },

  {
    title: "Ticket",
    path: "/ticket",
    icon: <ChecklistRtlIcon />,
    subMenu: [],
  },
  // {
  //   title: "Project Management",
  //   path: "/projectManagement",
  //   icon: <WorkOutlineIcon />,
  //   subMenu: [],
  // },
  // {
  //   title: "Client Management",
  //   path: "/clientManagement",
  //   icon: <PersonOutlineOutlinedIcon />,
  //   subMenu: [],
  // },
  // {
  //   title: "User Management",
  //   path: "/userManagement",
  //   icon: <PeopleAltOutlinedIcon />,
  //   subMenu: [],
  // },
  // {
  //   title: "Reports",
  //   path: "/feedbackReport",
  //   icon: <SummarizeOutlinedIcon />,
  //   subMenu: [],
  // },
  // {
  //   title: "Monthly Report",
  //   path: "/monthlyReport",
  //   icon: <SummarizeOutlinedIcon />,
  //   subMenu: [],
  // },
  {
    title: "Todo",
    path: "/todo",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
    target: "_blank"
  },
  {
    title: "Task",
    path: "/task",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
  },

  {
    title: "Master",
    path: "#",
    icon: <AutoAwesomeMosaicOutlinedIcon />,
    subMenu: [
      {
        title: "Questions",
        path: "/questions",
        subMenu: [],
      },
      {
        title: "Forms",
        path: "/forms",
        subMenu: [],
      },
      // {
      //   title: "Template",
      //   path: "/template",
      //   subMenu: [],
      // },

      {
        title: "Category",
        path: "/category",
        subMenu: [],
      },
      {
        title: "Hr and Admin work",
        path: "/hrAndAdminWork",
        subMenu: [],
      },
      {
        title: "Email",
        path: "/email",
        subMenu: [],
      },
    ],
  },
  {
    title: "Report Master",
    path: "#",
    icon: <AutoAwesomeMosaicOutlinedIcon />,
    subMenu: [
      {
        title: "Reports",
        path: "/feedbackReport",
        subMenu: [],
      },
      {
        title: "Monthly Report",
        path: "/monthlyReport",
        subMenu: [],
      },
      {
        title: "Report Category",
        path: "/reportCategory",
        subMenu: [],
      },
      {
        title: "HR Reports",
        path: "/hrReports",
        icon: <SummarizeOutlinedIcon />,
        subMenu: [],
      },
      {
        title: "IT Support Reports",
        path: "/itSupportReports",
        icon: <SummarizeOutlinedIcon />,
        subMenu: [],
      },
    ],
  },
];

const HRMenu = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <BrandingWatermarkOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Service Request",
    path: "/serviceRequest",
    icon: <AssignmentOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Staff Connect",
    path: "/feedback",
    icon: <FeedbackOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Case History",
    path: "/caseHistory",
    icon: <HistoryIcon />,
    subMenu: [],
  },
  {
    title: "Transaction",
    path: "/transaction",
    icon: <FlipToFrontOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Ticket",
    path: "/ticket",
    icon: <ChecklistRtlIcon />,
    subMenu: [],
  },
  {
    title: "HR Reports",
    path: "/hrReports",
    icon: <SummarizeOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Reports",
    path: "/feedbackReport",
    icon: <SummarizeOutlinedIcon />,
    subMenu: [],
  },

  {
    title: "Todo",
    path: "/todo",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
    target: "_blank"
  },
  {
    title: "Task",
    path: "/task",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Master",
    path: "#",
    icon: <AutoAwesomeMosaicOutlinedIcon />,
    subMenu: [
      {
        title: "Questions",
        path: "/questions",
        subMenu: [],
      },
      {
        title: "Forms",
        path: "/forms",
        subMenu: [],
      },
      // {
      //   title: "Template",
      //   path: "/template",
      //   subMenu: [],
      // },

      {
        title: "Category",
        path: "/category",
        subMenu: [],
      },
      {
        title: "Email",
        path: "/email",
        subMenu: [],
      },


      // {
      //   title: "Hr and Admin work",
      //   path: "/hrAndAdminWork",
      //   subMenu: [],
      // },
    ],
  },
];

const PMMenu = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <BrandingWatermarkOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Staff Connect",
    path: "/feedback",
    icon: <FeedbackOutlinedIcon />,
    subMenu: [],
  },
  {
    title: "Case History",
    path: "/caseHistory",
    icon: <HistoryIcon />,
    subMenu: [],
  },
  {
    title: "Ticket",
    path: "/ticket",
    icon: <ChecklistRtlIcon />,
    subMenu: [],
  },
  {
    title: "Todo",
    path: "/todo",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
    target: "_blank",
  },
  {
    title: "Task",
    path: "/task",
    icon: <TaskAltOutlinedIcon />,
    subMenu: [],
  },
  // {
  //   title: "Project Management",
  //   path: "/projectManagement",
  //   icon: <WorkOutlineIcon />,
  //   subMenu: [],
  // },
];

// IT Support sees the Project Manager menu plus its own responsibility report.
const ITMenu = [
  ...PMMenu,
  {
    title: "IT Support Reports",
    path: "/itSupportReports",
    icon: <SummarizeOutlinedIcon />,
    subMenu: [],
  },
];

export { Menu, HRMenu, PMMenu, ITMenu };
